import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "js-main-content" }
const _hoisted_2 = { class: "gfu-content-head" }
const _hoisted_3 = { class: "gfu-project-updates__header" }
const _hoisted_4 = {
  class: "gfu-hd gfu-hd--h1 gfu-project-updates__header-title",
  "data-qa": "page-title"
}
const _hoisted_5 = { class: "gfu-project-updates__wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "gfu-box gfu-project-updates__filters-box _mlb",
  "data-qa": "filterbox-section:UpdateSearch"
}
const _hoisted_7 = { class: "gfu-grid gfu-grid--gutter gfu-grid--gutter-tight gfu-project-updates__filters" }
const _hoisted_8 = { class: "gfu-grid__cell gfu-1of1 _pt-0" }
const _hoisted_9 = { class: "gfu-grid__cell gfu-1of1 gfu-1of4--m" }
const _hoisted_10 = { class: "gfu-grid__cell gfu-1of1 gfu-1of4--m" }
const _hoisted_11 = ["href", "data-qa"]
const _hoisted_12 = {
  key: 0,
  class: "gfu-box__tags"
}
const _hoisted_13 = {
  class: "_fw-eb _ffb",
  "format-key": "0"
}
const _hoisted_14 = {
  class: "_fw-eb _ffb",
  "format-key": "0"
}
const _hoisted_15 = {
  key: 0,
  class: "gfu-project-update__load-more-wrapper"
}
const _hoisted_16 = {
  key: 1,
  class: "gfu-box _mt-6",
  "data-qa": "updates-box"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_multi_selector_field = _resolveComponent("multi-selector-field")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_field_label = _resolveComponent("field-label")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_text_field = _resolveComponent("text-field")
  const _component_date_field = _resolveComponent("date-field")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_localize = _resolveComponent("localize")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_project_update_banner = _resolveComponent("project-update-banner")
  const _component_empty_state = _resolveComponent("empty-state")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.Resources.ProjectUpdates.PageHeader), 1 /* TEXT */),
        _withDirectives(_createVNode(_component_multi_selector_field, {
          modelValue: _ctx.selectFilters.projectUpdateUserContext,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectFilters.projectUpdateUserContext) = $event)),
          inline: true,
          "show-label": false,
          class: "gfu-project-updates__user-context-filter",
          name: "selectFilters.projectUpdateUserContext",
          options: $options.updateUserContextOptions,
          onChange: $options.handleProjectUpdateUserContext
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]), [
          [_vShow, !_ctx.isProcessing && $props.showUserContextFilter && $props.allowFilter]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"]),
      _createElementVNode("form", {
        onChange: _cache[5] || (_cache[5] = (...args) => ($options.handleFilterChange && $options.handleFilterChange(...args)))
      }, [
        ($props.allowFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_text_field, {
                    modelValue: $data.searchTerm,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.searchTerm) = $event)),
                    "display-name": _ctx.Resources.ProjectUpdates.SearchFieldLabel,
                    placeholder: _ctx.Resources.ProjectUpdates.SearchFieldPlaceholder,
                    "auto-complete": "off",
                    maxlength: 80,
                    "data-qa": "filtersbox-field:UpdateSearch"
                  }, {
                    label: _withCtx(() => [
                      _createVNode(_component_field_label, {
                        inline: true,
                        text: _ctx.Resources.ProjectUpdates.SearchFieldLabel
                      }, null, 8 /* PROPS */, ["text"]),
                      _createElementVNode("div", {
                        class: "gfu-link gfu-project-updates__filters-toggle",
                        onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.toggleEnableAdvancedSearch && $options.toggleEnableAdvancedSearch(...args)), ["prevent"])),
                        "data-qa": "updates-element:AdvSearchButton"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.Resources.ProjectUpdates.SearchFieldActionLink) + " ", 1 /* TEXT */),
                        _createVNode(_component_base_icon, {
                          name: "chevron-down",
                          class: "_ml-1"
                        })
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "display-name", "placeholder"])
                ]),
                ($data.enableAdvancedSearch)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_date_field, {
                          modelValue: _ctx.selectFilters.dateFrom,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.selectFilters.dateFrom) = $event)),
                          class: "_ma-0",
                          "display-name": _ctx.Resources.ProjectUpdates.SearchFieldDateFrom,
                          name: "selectFilters.dateFrom",
                          "show-label": true,
                          "data-qa": "date-field:MinDate"
                        }, null, 8 /* PROPS */, ["modelValue", "display-name"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_date_field, {
                          modelValue: _ctx.selectFilters.dateTo,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.selectFilters.dateTo) = $event)),
                          class: "_ma-0",
                          "display-name": _ctx.Resources.ProjectUpdates.SearchFieldDateTo,
                          name: "selectFilters.dateTo",
                          "show-label": true,
                          "data-qa": "date-field:MaxDate"
                        }, null, 8 /* PROPS */, ["modelValue", "display-name"])
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ], 32 /* NEED_HYDRATION */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.updates, (update, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: update.id,
          class: _normalizeClass(["gfu-project-update__container", {'_mt-6': index === 0}])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["gfu-project-update__badge", {'gfu-project-update__trace': index > 0}])
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "gfu-project-update__badge-inner" }, null, -1 /* CACHED */)
          ]))], 2 /* CLASS */),
          _createElementVNode("a", {
            class: "gfu-box gfu-box--thick gfu-box--no-fx",
            href: update.projectUpdateUrl,
            "data-qa": 'update-container:' + update.projectUpdateID
          }, [
            (update.pollInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_base_badge, {
                    theme: $options.getPollLabel(update).theme
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.getPollLabel(update).text), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme"])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_project_update_banner, {
              update: update,
              "show-info": true
            }, {
              date: _withCtx(() => [
                (update.updatedAt)
                  ? (_openBlock(), _createBlock(_component_tooltip, {
                      key: 0,
                      class: "_mr-1"
                    }, {
                      content: _withCtx(() => [
                        _createVNode(_component_localize, {
                          tag: "div",
                          resource: _ctx.Resources.ProjectUpdates.OriginallyPublished
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$format(update.publishedAt)), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"]),
                        _createVNode(_component_localize, {
                          tag: "div",
                          resource: _ctx.Resources.ProjectUpdates.LastModified
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$format(update.updatedAt)), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_base_icon, { name: "circle-info" })
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.$format(update.publishedAt)), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["update"])
          ], 8 /* PROPS */, _hoisted_11)
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */)),
      ($options.canLoadMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "gfu-project-update__trace" }, null, -1 /* CACHED */)),
            _createElementVNode("button", {
              type: "button",
              class: "gfu-project-update__load-more gfu-btn gfu-btn--block gfu-btn--secondary-alt",
              onClick: _cache[6] || (_cache[6] = (...args) => ($options.loadMoreUpdates && $options.loadMoreUpdates(...args))),
              "data-qa": "updates-list-element:LoadMore"
            }, [
              _createTextVNode(_toDisplayString(_ctx.Resources.Common.LoadMoreButton) + " ", 1 /* TEXT */),
              _createVNode(_component_base_icon, {
                name: "angle-down",
                size: "2x",
                class: "_tc--accent _ml-1 _tvam"
              })
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($data.updates.length === 0 && $data.isInitalized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            ($data.isSearchResult)
              ? (_openBlock(), _createBlock(_component_empty_state, {
                  key: 0,
                  title: _ctx.Resources.ProjectUpdates.EmptyStateSearchTitle,
                  description: _ctx.Resources.ProjectUpdates.EmptyStateSearchParagraph,
                  "data-qa": "empty-search-state"
                }, null, 8 /* PROPS */, ["title", "description"]))
              : (_openBlock(), _createBlock(_component_empty_state, {
                  key: 1,
                  title: _ctx.Resources.ProjectUpdates.EmptyStateTitle,
                  description: _ctx.Resources.ProjectUpdates.EmptyStateParagraph,
                  "data-qa": "empty-state"
                }, null, 8 /* PROPS */, ["title", "description"]))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}